<template>
    <Modal v-model="open" :title="title">
      <CheckboxGroup v-model="selectedRegions">
        <Checkbox
          v-for="region in regionData"
          :label="region.area_id.toString()"
          :key="region.area_id.toString()"
        >
          {{ region.area_name }}
        </Checkbox>
      </CheckboxGroup>
      <div slot="footer" style="text-align: center">
        <Button @click="cancel">关闭</Button>
        <Button type="primary" :loading="loading" @click="ok">
          提交
        </Button>
      </div>
    </Modal>
  </template>
  <script>
  // 引入获取区域列表和设置角色区域的API方法
  import { getAreaList, getAreaListByRole } from '@/api/area'
  import { rolesSetAreas } from '@/api/role'
  
  export default {
    name: 'rolesAddUpdateRegion', // 组件名称
    data() {
      return {
        role_id: '', // 角色ID
        open: false, // 控制模态框的显示与隐藏
        title: '分配区域', // 模态框标题
        loading: false, // 控制加载状态的显示与隐藏
        selectedRegions: [], // 已选择的区域ID数组
        regionData: [], // 区域数据列表
      }
    },
    methods: {
      // 初始化组件的函数
      init(params) {
        this.role_id = params.roleId || params.role_id // 设置角色ID
        // 获取区域ID数组，并确保转换为字符串数组（CheckboxGroup需要字符串）
        const areaIds = params.areaIds || params.area_ids || []
        // 确保是数组，并将所有元素转换为字符串
        this.selectedRegions = Array.isArray(areaIds) 
          ? areaIds.map(id => String(id))
          : []
        console.log('初始化区域选择:', {
          role_id: this.role_id,
          selectedRegions: this.selectedRegions,
          rawAreaIds: areaIds
        })
        this.title = '分配区域' // 设置模态框标题
        this.open = true // 显示模态框
        this.getList() // 调用getList方法获取区域列表
      },
      // 获取区域列表的函数
      getList() {
        getAreaList() // 调用getAreaList API获取区域列表
          .then((res) => { // 处理成功的响应
            if (res.data.code === 200) { // 如果响应码为200，表示成功
              this.regionData = res.data.data // 将响应数据赋值给regionData
              
              // 处理字段名称转换
              if (this.regionData && this.regionData.length > 0) {
                this.regionData.forEach(item => {
                  if (item.areaId !== undefined && item.area_id === undefined) {
                    item.area_id = item.areaId;
                  }
                  if (item.areaName !== undefined && item.area_name === undefined) {
                    item.area_name = item.areaName;
                  }
                });
              }
              
              console.log('区域列表加载完成，数量:', this.regionData?.length || 0)
              console.log('已选择的区域:', this.selectedRegions)
            } else {
              this.$Message.error(res.data.msg) // 如果响应码不是200，显示错误消息
            }
          })
          .catch((err) => { // 处理错误的响应
            console.error('获取区域列表失败:', err)
            this.$Message.error(err?.message || err || '获取区域列表失败') // 显示错误消息
          })
      },
      // 确认提交分配区域的函数
      ok() {
        // 将字符串数组转换为数字数组（后端需要数字）
        const areaIds = this.selectedRegions.map(id => {
          const numId = parseInt(id, 10)
          return isNaN(numId) ? id : numId
        })
        
        const postData = { // 准备提交的数据
          area_ids: areaIds, // 已选择的区域ID数组（转换为数字）
          role_id: this.role_id, // 角色ID
        }
        this.loading = true // 显示加载状态
        console.log('提交分配区域数据:', postData)
        console.log('原始selectedRegions:', this.selectedRegions)
        rolesSetAreas(postData) // 调用rolesSetAreas API设置角色区域
          .then((res) => { // 处理成功的响应
            this.loading = false // 隐藏加载状态
            console.log('分配区域API响应:', res.data)
            if (res.data.code === 200) { // 如果响应码为200，表示成功
              this.$Message.success('分配区域成功') // 显示成功消息
              this.cancel() // 调用cancel函数关闭模态框
              this.$emit('reload') // 触发reload事件，通知父组件重新加载列表
              // 更新Vuex store中的区域数据，以便车辆管理界面能立即显示新区域
              this.updateAreaStore()
            } else {
              this.$Message.error(res.data.msg || '分配区域失败') // 如果响应码不是200，显示错误消息
            }
          })
          .catch((err) => { // 处理错误的响应
            this.loading = false // 隐藏加载状态
            console.error('分配区域失败:', err)
            this.$Message.error(err?.message || err || '分配区域失败') // 显示错误消息
          })
      },
      // 取消操作并关闭模态框的函数
      cancel() {
        this.open = false // 隐藏模态框
      },
      
      // 更新Vuex store中的区域列表
      async updateAreaStore() {
        try {
          console.log('开始更新Vuex store中的区域列表...')
          // 重新获取当前角色的区域列表并更新store
          const res = await getAreaListByRole()
          console.log('getAreaListByRole 响应:', res.data)
          if (res.data.code === 200) {
            // 更新Vuex store中的区域数据
            this.$store.commit('setareas', JSON.stringify(res.data.data))
            console.log('✅ 区域列表已更新到Vuex store，区域数量:', res.data.data?.length || 0)
            console.log('区域列表数据:', res.data.data)
          } else {
            console.error('❌ 获取区域列表失败:', res.data.msg)
          }
        } catch (error) {
          console.error('❌ 更新区域列表失败:', error)
        }
      },
    },
  }
  </script>
  
  